import { IBienLaiPrintRequest } from "./../../state/action-types/bien-lai/IBienLaiViewChiTietActionTypes";
import {
  IBienLaiHuyRequest,
  IBienLaiHuyTheoLopRequest,
} from "../../model/request/bien-lai/IBienLaiHuyRequest";
import { IBienLaiPagingRequest } from "../../model/request/bien-lai/IBienLaiPagingRequest";
import { IBienLaiSelectByLopRequest } from "../../model/request/bien-lai/IBienLaiSelectByLopRequest";
import { IBienLaiSelectBySinhVienRequest } from "../../model/request/bien-lai/IBienLaiSelectBySinhVienRequest";
import { IBienLaiThuTheoLopCreateRequest } from "../../model/request/bien-lai/IBienLaiThuTheoLopCreateRequest";
import { apiClient } from "../apiClient";
import { IBienLaiThuCreateRequest } from "./../../model/request/bien-lai/IBienLaiThuCreateRequest";
import { IBienLaiSelectByThiSinhRequest } from "../../model/request/bien-lai/IBienLaiSelectByThiSinhRequest";
import { IBienLaiChangeChoPhepXuatHDRequest } from "../../model/request/bien-lai/IBienLaiChangeChoPhepXuatHDRequest";
import { IBienLaiSaveImportRequest } from "../../model/request/bien-lai/IBienLaiSaveImportRequest";
import { IBienLaiThuTheoLopRequest } from "../../model/request/bien-lai/IBienLaiThuTheoLopRequest";
export const BIEN_LAI_ENDPOINT = "bien-lai-thu";

export const bienLaiThuApi = {
  Create: (request: IBienLaiThuCreateRequest) =>
    apiClient.post(BIEN_LAI_ENDPOINT, request),
  CreateByLop: (request: IBienLaiThuTheoLopCreateRequest) =>
    apiClient.post(`${BIEN_LAI_ENDPOINT}/create-by-lop`, request),
  SelectBySinhVien: (request: IBienLaiSelectBySinhVienRequest) =>
    apiClient.get(
      `bien-lai-thu/nam-hoc/${request.nam_hoc}/hoc-ky/${request.hoc_ky}/sinh-vien/${request.id_sv}`,
    ),
  SelectByLop: (request: IBienLaiSelectByLopRequest) =>
    apiClient.get(
      `bien-lai-thu/nam-hoc/${request.nam_hoc}/hoc-ky/${request.hoc_ky}/lop/${request.id_lop}`,
    ),
  HuyByLop: (request: IBienLaiHuyTheoLopRequest) =>
    apiClient.post(`${BIEN_LAI_ENDPOINT}/huy-by-lop`, request),
  SelectByIDBienLai: (id_bien_lai: number) =>
    apiClient.get(`bien-lai-thu/${id_bien_lai}`),
  SelectBySoPhieuGroup: (request: IBienLaiThuTheoLopRequest) =>
    apiClient.get(
      `bien-lai-thu/hoc_ky/${request.hoc_ky}/nam_hoc/${request.nam_hoc}/so_phieu_group/${request.so_phieu_group}`,
    ),
  PrintBienLai: (request: IBienLaiPrintRequest) =>
    apiClient.post(`bien-lai-thu/print`, request),
  SelectPaging: (request: IBienLaiPagingRequest) =>
    apiClient.post(`${BIEN_LAI_ENDPOINT}/select-data-paging`, request),
  Huy: (request: IBienLaiHuyRequest) =>
    apiClient.post(`${BIEN_LAI_ENDPOINT}/huy`, request),

  ChangeChoPhepXuatHoaDon: (request: IBienLaiChangeChoPhepXuatHDRequest) =>
    apiClient.post(
      `${BIEN_LAI_ENDPOINT}/change-cho-phep-xuat-hoa-don`,
      request,
    ),

  Preview: (request: IBienLaiThuCreateRequest) =>
    apiClient.post(`${BIEN_LAI_ENDPOINT}/preview`, request),

  SelectByThiSinh: (request: IBienLaiSelectByThiSinhRequest) =>
    apiClient.get(
      `bien-lai-thu/nam-tuyen-sinh/${request.nam_tuyen_sinh}/thi-sinh/${request.id_thi_sinh}`,
    ),

  ExportExcel: (request: IBienLaiPagingRequest) =>
    apiClient.post(`${BIEN_LAI_ENDPOINT}/export-excel`, request),
  Print: (request: IBienLaiPagingRequest) =>
    apiClient.post(`${BIEN_LAI_ENDPOINT}/print-report`, request),
  SyncKeToanFast: (request: number[]) =>
    apiClient.post(`ket-noi-du-lieu/fast/receipt`, request),

  Import: (request: FormData) =>
    apiClient.upload(`${BIEN_LAI_ENDPOINT}/import`, request),
  SaveImport: (request: IBienLaiSaveImportRequest) =>
    apiClient.post(`${BIEN_LAI_ENDPOINT}/save-import`, request),
};
